<div class="bg-white">
  <div class="border-bottom p-4">
    <h3>{{ 'Sellers.Products.AddQuickQassatly' | translate }}</h3>
  </div>

  <div class="p-4">
    <div class="container">
      <form [formGroup]="stepForm" *ngIf="stepForm">
        <div class="row justify-content-end">
          <div class="col-md-6 mb-3">
            <app-number [fieldObject]="controllers['Amount']"
                        [fieldErrors]="formValidator.formErrors"
                        [formControlRef]="convertControls(controllers['Amount'].fieldName)"
                        [productType]="productTypeId"
                        [isUpdate]="isUpdate"></app-number>
          </div>
          <div class="col-md-6 mb-3">
            <app-text [fieldObject]="controllers['Name']"
                      [fieldErrors]="formValidator.formErrors"
                      [formControlRef]="convertControls('Name')"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-text>
          </div>
          <div class="col-md-6 mb-3">
            <app-text [fieldObject]="controllers['Buyer Email']"
                      [fieldErrors]="formValidator.formErrors"
                      [formControlRef]="convertControls('Buyer Email')"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-text>
          </div>
          <div class="col-md-6 mb-3">
            <app-phone [fieldObject]="controllers['Buyer Mobile Number']"
                      [fieldErrors]="formValidator.formErrors"
                      [formControlRef]="convertControls('Buyer Mobile Number')"
                      [productType]="productTypeId"
                      [isUpdate]="isUpdate"></app-phone>
            <span style="font-weight:500;">{{ 'QUICK_QASSATLY.QUICK_QASSATLY_EXTRA_MESSAGE' | translate }}</span>
          </div>
          <div class="col-auto">
            <button class="btn btn-primary" type="button" [disabled]="!stepForm.valid"
                    (click)="submit()">
              {{ 'Sellers.Products.Submit' | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
